export const TranslationsDA = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: 'Start Bestilling',
        cart: 'Kurv',
        open_24: '24 Timer',
        closed: 'Lukket',
        free: 'Gratis',
        something_went_wrong: 'Øv.. noget gik galt',
        try_again: 'Prøv igen',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Mandag',
                tuesday: 'Tirsdag',
                wednesday: 'Onsdag',
                thursday: 'Torsdag',
                friday: 'Fredag',
                saturday: 'Lørdag',
                sunday: 'Søndag',
            },
        },
        services: {
            pickup: 'Hent Selv',
            delivery: 'Levering',
            dine_in: 'Spiser Her',
            table_booking: 'Book Bord',
        },
        payment: {
            method: {
                cash: 'Kontant',
                card: 'Kort',
                stripe: 'Betalingskort',
                paypal: 'PayPal',
                cardconnect: 'Betalingskort',
                paygate_payweb: 'Betalingsport',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora',
                pesapal: 'Pesapal',
                custom: 'Brugerdefineret',
            },
            backend_method: {
                cash: 'Kontant',
                card: 'Kort',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora',
                pesapal: 'Pesapal',
                custom: 'Brugerdefineret',
            },
            status: {
                success: 'Fuldført',
                pending: 'Arbejder',
                error: 'Fejl',
                refunded: 'Tilbagebetaling',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Fjern',
                drop_here: 'Drop filerne her, eller klik for at vælge fil',
                accepts: 'Vi acceptere {{fileTypes}} filtyper',
                errors: {
                    max_files: 'Maks {{number}} tilladt',
                    max_size: 'Maks fil størrelse på {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'Det valgte tidspunkt er udenfor vores åbningstid, prøv med et andet tidspunkt',
            },
            buttons: {
                order: {
                    book_order: 'Book Bord / Bestil Mad',
                    order_online: 'Start Bestilling',
                    book_table: 'Book Bord',
                    order: 'Bestil',
                    book: 'Bord',
                    cart: 'Kurv',
                    restart: 'Start Forfra',
                    closed: 'Butikken er lukket',
                    not_accepting: 'Vi accepterer pt. ingen bestillinger',
                },
            },
        },
        modals: {
            auth: {
                login: 'Login',
                register: 'Registre',
                register_commence: 'Fortsæt',
                register_complete: 'Bruger Oprettet',
                register_confirmation_sent: 'En bekræftigelseskode er blevet sendt til din mail. Indtast koden her for at fortsætte',
                register_confirmation_resent: 'En bekræftigelseskode er blevet sendt igen, tjek din spam-mappe eller prøv igen.',
                register_restart: 'Forfra',
                register_resend_code: 'Send igen',
                login_placeholder: 'E-mail',
                password_placeholder: 'Adgangskode',
                confirm_password_placeholder: 'Bekræft Adgangskode',
                confirmation_code_placeholder: 'E-Mail Bekræftigelseskode',
                accept_terms: 'Accepter betingelser og vilkår',
                accept_terms_view: 'Se',
                login_facebook: 'Login Med Facebook',
                login_google: 'Login Med Google',
                benefits: 'Med en bruger kan du nemt genbestille tidligere ordre.',
                logged_in: 'Velkommen',
                logged_out: 'På Gensyn',
                password_reset: {
                    init_button: 'Nulstil Adgangskode',
                    init_success: 'Link til nulstilling af adgangskode er blevet sendt til din e-mail',
                    complete_button: 'Ny Adgangskode',
                    complete_success: 'Adgangskoden er ændret, login igen med din nye adgangskode',
                    forgot_password_text: 'Glemt Adgangskode?',
                    forgot_password_link: 'Nulstil adgangskode',
                    remember_password_text: 'Husk Adgangskoden?',
                    remember_password_link: 'Gå tilbage',
                    invalid_title: 'Nulstilling Af Adgangskode Er Ugyldigt',
                    invalid_description: 'Ugyldigt nulstillingslink, anmod om et nyt link',
                    invalid_link: 'Gå Til Login',
                    title: 'Nulstil Adgangskode',
                    description: 'Indtast ny adgangskode',
                },
                error_generic: 'Øv.. noget gik galt, prøv igen eller kontakt os',
                error_accept_terms: 'Accepter betingelser og vilkår',
                error_password_length: 'Adgangskode skal være på mindst 6 tegn',
                error_social: 'Øv.. noget gik galt, prøv igen eller kontakt os',
                error_confirmation_code: 'Ugyldig bekræftelseskode',
                error_invalid_code: 'Ugyldig Kode',
                error_exists: 'Brugeren findes allerede',
                error_invalid_email_pass: 'Ugyldig e-mail eller adgangskode',
                error_password_no_match: 'Adgangskoder matcher ikke hinanden',
                error_user_not_found: 'Ingen bruger med den e-mail',
                error_invalid_email: 'Ugyldig e-mail',
                error_invalid_reset_token: 'Ugyldigt nulstillingslink, anmod om et nyt link',
            },
            booking: {
                form: {
                    name: 'Fulde navn',
                    email: 'E-Mail',
                    phone: 'Telefonnummer',
                    number_of_people: 'Antal Pers.',
                    number_of_people_max: 'Maks ({{max_people}} Personer)',
                    number_of_people_min: 'Mindst ({{min_people}} Personer)',
                    number_of_people_max_min: 'Antal Personer (mellem {{min_people}} og {{max_people}})',
                    notes: 'Kommentar',
                    submit: 'Indsend',
                    email_optional: '(valgfrit)',
                    date: 'Dato',
                    duration: 'Varighed',
                    seating: 'Ledige tidspunkter',
                    number_of_guests: 'Antal gæster',
                    notes_placeholder: 'Allergier, anledning, pladsønske',
                    reserving: 'Reserverer...',
                    reserve_table: 'Reservér bord',
                    please_choose_a_date_and_time: 'Vælg en dato og et tidspunkt.',
                    invalid_people: 'Antallet af personer skal være mellem {{min}} og {{max}}.',
                    party_size_max_fallback: 'det tilladte maksimum',
                    loading_available_times: 'Indlæser ledige tidspunkter…',
                    select_a_date_to_see_available_times: 'Vælg en dato for at se ledige tidspunkter.',
                    no_times_available_for_this_date: 'Ingen ledige tidspunkter på denne dato. Vælg en anden dag.',
                    shift: 'Vagt',
                    service_times: 'Servicetider',
                    new_shift: 'Ny vagt',
                    time: 'tidspunkt',
                    times: 'tidspunkter',
                    unavailable: 'Ikke ledig',
                    available: 'Ledig',
                    required_name: 'Indtast dit navn.',
                    required_phone: 'Indtast dit telefonnummer.',
                    required_email: 'Indtast din e-mailadresse.',
                    invalid_email: 'Indtast en gyldig e-mailadresse.',
                    required_terms: 'Acceptér vilkårene, før du reserverer.',
                    missing_custom_fields: 'Besvar alle obligatoriske spørgsmål.',
                    reservation_is_unavailable: 'Reservation er ikke mulig.',
                    please_contact_the_restaurant_directly: 'Kontakt restauranten direkte.',
                    almost_done: 'Næsten færdig',
                    your_details: 'Dine oplysninger',
                    tell_us_who_s_coming: 'Fortæl os, hvem der kommer, så vi kan bekræfte din reservation.',
                    book_your_table: 'Reservér dit bord',
                    choose_a_time_that_works_for_you: 'Vælg et tidspunkt, der passer dig.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Send din reservationsanmodning, så klarer restauranten resten.',
                    select_date: 'Vælg dato',
                    standard: 'Standard',
                    minutes: 'minutter',
                    next: 'Næste →',
                    back: '← Tilbage',
                    accept_terms: 'Jeg accepterer vilkår og betingelser.',
                    info_1: 'Du modtager en mail, når din booking er accepteret',
                },
                errors: {
                    not_found: 'Bestilling findes ikke. Den blev muligvis slettet',
                    generic: 'Der gik noget galt, prøv igen eller kontakt os',
                    something_went_wrong: 'Noget gik galt',
                    accept_terms: 'Accepter betingelser og vilkår',
                    required_phone: 'Indtast dit telefonnummer',
                    required_email: 'Indtast din e-mail',
                    required_name: 'Indtast dit navn',
                    invalid_email: 'Indtast gyldig e-mail',
                    invalid_phone: 'Indtast gyldigt telefonnummer',
                    invalid_people: 'Ugyldig antal pers.',
                    booking_capacity_threshold: 'Vi er fuldt booket på dette tidspunkt. Prøv et andet tidspunkt.',
                    slot_unavailable: 'Vi er fuldt booket for dette antal personer. Prøv et andet tidspunkt.',
                    booking_date_paused: 'Reservationer er sat på pause for denne dato. Vælg en anden dag.',
                    invalid_table_assignment: 'De borde kan ikke rumme dit selskab. Vælg et andet tidspunkt.',
                    exceeded_order_limit: 'For mange reservationsanmodninger. Prøv igen senere.',
                    validation_failed_recaptcha_v3: 'Usædvanlig trafik registreret. Bruger du VPN? Gennemfør kontrollen ovenfor, og prøv igen.',
                    validation_failed_recaptcha_v2: 'Reservationen kunne ikke startes. Prøv igen, eller brug en anden metode. Hvis du bruger VPN, så prøv at slå det fra først.',
                    booking_already_exists: 'Denne reservation er allerede sendt. Tjek din e-mail, eller åbn dit reservationslink.',
                    invalid_party_size: 'Vælg et gyldigt antal personer.',
                    invalid_request: 'Ugyldig anmodning. Opdatér siden, og prøv igen.',
                    table_booking_unavailable: 'Bordreservation er ikke mulig.',
                },
            },
            cart: {
                title: 'Kurv',
                proceed_to_checkout: 'Fortsæt',
                edit_dish: 'Ændre',
                remove_dish: 'Fjern',
                no_items_1: 'Kurven er tom',
                no_items_2: 'Tilføj noget for at fortsætte',
                free_delivery_notice: 'Gratis levering for bestillinger over {{value, currency}}',
                errors: {
                    min_order_promo: 'Minimum bestilling på {{value, currency}} kræves inden rabatkoden kan bruges',
                    min_order_delivery: 'Minimum bestilling på {{value, currency}} for levering',
                },
                promo: {
                    heading: 'Rabatkode',
                    placeholder: 'Indtast din rabatkode',
                    add: 'Indtast Kode',
                    title: 'Rabatkode {{name}} tilføjet',
                    fixed_discount: '{{value, currency}} af',
                    percent_discount: '{{value}}% af',
                    added_to_cart: 'Rabatkode tilføjet',
                    errors: {
                        not_found: 'Rabatkoden findes ikke',
                        disabled: 'Rabatkoden er udløbet',
                        not_available: 'Rabatkoden er i øjeblikket ikke tilgængelig',
                        logged_in_only: 'Login for at anvende rabatkoden',
                        already_used: 'Er allerede anvendt',
                        invalid: 'Rabatkoden er ugyldig',
                        invalid_service: 'Rabatkoden er ikke gyldig for den valgte service',
                        later_only: 'Gælder kun forudbestillinger',
                        now_only: 'Gælder kun bestillinger, der ikke er forudbestilt',
                        generic: 'Hov... noget gik galt, prøv igen',
                        dishes_required_multi: 'Rabatkoden er gyldig, når bestemte retter føjes til kurven',
                        dishes_required_single: "Rabatkoden er gyldig for denne '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Drikkepenge',
                    placeholder: 'Valgfrit',
                },
            },
            checkout: {
                title: 'Bestilling',
                subtitle: 'Bekræft bestilling',
                details: {
                    service: 'Ydelser',
                    due: 'Til',
                    due_now_asap: 'Hurtigst muligt',
                    address: 'Leveringsadresse',
                    total: 'Total',
                    table: 'Bord',
                    store_location: 'Adresse',
                },
                customer: {
                    title: 'Kunde',
                    subtitle: 'Login for at gemme din bestillinger til en anden dag',
                    button: 'Login',
                    name: 'Fulde Navn',
                    email: 'E-Mail',
                    phone: 'Telefonnummer',
                    phone_important: 'Telefonnummer (Påkrævet)',
                    notes: 'Kommentar',
                    delivery_notes: 'Kommentar',
                    optional: 'Valgfri',
                },
                payment: {
                    title: 'Betalingsmetode',
                },
                accept_terms: 'Accepter Betinglser & Vilkår',
                accept_terms_view: 'Se',
                processing_order: 'Behandler Din Bestilling',
                warning: {
                    different_payment_currency: 'Butiksprisen er i {{store_currency}} men betalingsmetoden er i {{payment_currency}}',
                    closing_soon: 'Lukker snart, nye bestillinger skal ske inden {{value}} minutter',
                    closed: 'Beklager, denne service er lukket, og bestillinger accepteres ikke',
                    expired: 'Vi kan ikke længere opfylde din bestilling på det valgte tidspunkt. Vælg et andet tidspunkt',
                },
                errors: {
                    stripe_generic: 'Kreditkortfejl, prøv igen eller vælg en anden betalingsmetode',
                    validation_failed: 'Denne betaling kan ikke accepteres på nuværende tidspunkt. Prøv venligst igen senere, eller vælg en anden betalingsmetode.',
                    stripe_loading_fail: 'Fejl ved indlæsning af betalingsmetode, prøv igen',
                    something_went_wrong: 'Noget gik galt',
                    paypal_generic: 'Der gik noget galt, prøv igen eller vælg en anden betalingsmetode',
                    payment_fail: 'Indbetaling mislykkedes. Prøv igen eller vælg en anden betalingsmetode',
                    payment_cancelled: 'Indbetaling annulleret, prøv igen eller vælg en anden betalingsmetode',
                    payment_error: 'Fejl ved behandling af online betaling, prøv igen eller vælg en anden betalingsmetode',
                    payment_declined: 'Din indbetaling blev afvist',
                    card_declined: 'Dit kort blev afvist, og indbetaling kunne ikke behandles',
                    promo_max_uses_exceeded: "Denne kampagnekode har nået sin brugsgrænse og er ikke længere tilgængelig.",
                    store_closed: 'Butikken er lukket og accepterer ikke flere bestillinger',
                    accept_terms: 'Accepter betingelser & vilkår',
                    required_payment: 'Vælg en betalingsmetode',
                    required_phone: 'Indtast dit telefonnummer',
                    required_email: 'Indtast din e-mail',
                    required_name: 'Indtast dit navn',
                    invalid_email: 'Indtast en gyldig e-mail',
                    invalid_phone: 'Indtast et gyldig telefonnummer',
                    invalid_cc_number: 'Dit kreditkortnummer er ugyldigt',
                    retry_cc_number: 'Der gik noget galt, indtast dit kreditkortnummer igen, og prøv igen',
                    closed: 'Butikken er lukket / lukker og accepterer ikke flere ordrer',
                    promo_login_required: 'Man skal være logget ind for at anvende rabatkoden',
                    promo_used: 'Du har allerede anvendt rabatkoden',
                    exceeded_order_limit: 'Vi modtager mange bestillinger lige nu. Vælg venligst et senere tidspunkt.',
                    exceeded_order_limit_later: 'Vi kan ikke længere opfylde din bestilling på det valgte tidspunkt. Vælg venligst en senere dato eller tidspunkt.',
                },
                button: {
                    continue: 'Fortsæt',
                    place_order: 'Start Bestilling',
                },
            },
            customer: {
                age_v: {
                    title: 'Aldersbekræftelse',
                    required_for_items: 'Påkrævet for at bestille visse varer',
                    min_age: 'Mindste alder: {{age}} år',
                    est_time: 'Estimeret bekræftelsestid: {{time}} timer',
                    upload_description: 'Upload dit ID nedenfor til bekræftelse. Du får besked på e-mail, når du er verificeret. Upload op til 2 billeder med en maksimal størrelse på 2 MB hver',
                    pending_description_1: 'Tak, fordi du indsendte dine dokumenter. Du får besked via e-mail, når du er godkendt',
                    pending_description_2: 'Opdater siden for at opdatere din bekræftelsesstatus. Estimeret bekræftelsestid er {{time}} timer',
                    approved_description: 'Din konto er verificeret, og du kan bestille fra begrænsede menuer',
                    rejected_description: 'Din ID er blevet afvist. Hvis du ønsker at prøve igen, skal du uploade dit ID igen',
                    upload: 'Upload',
                    reupload: 'Gen-Upload Filen',
                    go_back: 'Gå Tilbage',
                    view_document: 'Se Dokument {{number}}',
                    status: {
                        unverified: 'Ikke-verificeret',
                        pending: 'Venter Godkendelse',
                        approved: 'Bekræftet',
                        rejected: 'Afvist',
                    },
                },
                headings: {
                    sessions: 'Sessioner',
                    orders: 'Bestillinger',
                    spend: 'Anvend',
                    order_history: 'Historik',
                    loyalty_points: 'Pikat e besnikërisë',
                },
            },
            custom_payment: {
                title: '{{name}} Betalingsformular',
                description: 'Udfyld felterne herunder for at betale. Hvis der ikke indtastes et beløb, gemmes dine oplysninger uden at du bliver opkrævet.',
                disabled: 'Betalingssiden er ikke konfigureret korrekt. Kontakt webstedsejeren for at rette problemet.',
                success: 'Mange tak, din indbetaling er gennemført, og dine detaljer er blevet gemt.',
                back: 'Tilbage til forsiden',
                fields: {
                    name: 'Fulde Navn',
                    email: 'E-mail',
                    reference: 'Betalings Ref.',
                    amount: 'Antal (kr.)',
                    name_on_card: 'Navn På Kort',
                    submit: 'Betal',
                },
                warning: {
                    currency: 'Bemærk: Betalingsbeløb i {{actual}}, ikke {{default}}',
                },
                errors: {
                    generic: 'Noget gik galt, prøv igen eller kontakt os',
                    stripe_generic: 'Kreditkortfejl, prøv igen',
                    payment_fail: 'Indbetaling mislykkedes. Prøv igen eller vælg en anden betalingsmetode',
                    payment_cancelled: 'Indbetaling annulleret, prøv igen eller vælg en anden betalingsmetode',
                    payment_error: 'Fejl ved behandling af din online betaling, prøv igen eller vælg en anden betalingsmetode',
                    payment_declined: 'Din indbetaling blev afvist',
                    card_declined: 'Dit kort blev afvist, hvorfor din indbetaling ikke kunne behandles',
                    promo_max_uses_exceeded: "Denne kampagnekode har nået sin brugsgrænse og er ikke længere tilgængelig.",
                },
            },
            dish: {
                add: 'Tilføj',
                edit: 'Ændre',
                notes: 'Kommentar',
                ingredients: {
                    title: 'Fjern fyld',
                    uncheck_remove: 'Vælg for at fjerne',
                },
                ingredients_title: 'Fjern fyld',
                combo: {
                    choose_dish: 'Vælg En Ret',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Vælg en (Påkrævet)',
                        select_one_optional: 'Vælg en',
                        select_between: 'Vælg mellem {{min}} - {{max}} (Påkrævet)',
                        select_at_least: 'Vælg mindst {{qty}} (Påkrævet)',
                        select_up_to: 'Vælg op til {{qty}} (Påkrævet)',
                        select_multiple: 'Vælg flere',
                        free_amount: 'De Første {{qty}} Er Gratis / {{selected}} Er Valgt',
                    },
                },
                error: 'Du bedes rette de røde felter',
                added_to_cart: 'Tilføjet i kurven',
            },
            map: {
                zone_fee: 'Leveringsgebyr',
                view_in_google: 'Se i Google Maps',
            },
            portal_go_back: {
                title: 'Tilbage til Restaurant søgning?',
                description: 'Kurven bliver tømt',
                cancel: 'Annullere',
                proceed: 'Gå Tilbage',
            },
            order: {
                config: {
                    services: {
                        title: 'Vælg Service',
                        table_booking: 'Book Bord',
                    },
                    address_custom: {
                        input_placeholder: 'Indtast din adresse',
                    },
                    address: {
                        input_placeholder: 'Leveringsadresse',
                        extras_placeholder: 'Hus nr, Bygnings nr, Opgangs nr.',
                        search_placeholder: 'Søg efter adresse',
                        not_found: 'Leveringsadressen blev ikke fundet, prøv igen',
                        not_delivering: 'Vi leverer i øjeblikket ikke til den valgte adresse',
                        not_in_range: 'Øv.. du er desværre for langt væk fra os',
                        not_in_zone: 'Din adresse er ikke indenfor vores leveringsområde',
                    },
                    datetime: {
                        title: 'Hvornår kunne du tænke dig din bestilling?',
                        due_now: 'Hurtigst Muligt',
                        due_later: 'Tidspunkt',
                        service_not_available: 'Beklager, vi modtager i øjeblikket ikke bestillinger for {{service}}',
                        currently_closed: 'Vælg dato og tidspunkt',
                        due_unavailable: 'Ikke Tilgængelig',
                        due_closed: 'Lukket',
                        select_date: 'Vælg Dato',
                        select_time: 'Vælg Tidspunkt',
                        select_order_date: 'Vælg Dato',
                        select_order_time: 'Vælg Tidspunkt',
                        select_order_date_time: 'Vælg din bestillingsdato/tid',
                        select_booking_date: 'Vælg Dato',
                        select_booking_time: 'Vælg Tidspunkt',
                        no_times_available: 'Ingen ledige tidspunkter',
                        date_today: '(I Dag)',
                        date_closed: '(Lukket)',
                        date_bookings_paused: '(Reservationer på pause)',
                        time_slot_closed: 'Lukket',
                    },
                    number_of_people: {
                        placeholder: 'Antal Personer',
                    },
                    table: {
                        select: 'Vælg',
                        select_popup_title: 'Vælg Bord',
                        password: 'Bord Kode',
                        password_warning: 'Indtast Bord Kode for at fortsætte',
                    },
                    warning: {
                        closed: 'Beklager, vi har lukket',
                        not_available: 'Beklager, vi modtager i øjeblikket ingen bestillinger',
                    },
                    eta: {
                        delivery: `Estimert leveringstid er ca. {{minutesToCustomer}} min.`,
                        pickup: `Din bestilling er klar om ca. {{minutesToCustomer}} min.`
                    },
                    start_button: 'Start Bestilling',
                },
                history: {
                    invalid: 'Øv.. genbestilling kan ikke foretages, da nogen af retterne endten er blevet ændret eller fjernet',
                },
                reorder: {
                    title: 'Hurtig Genbestilling',
                    description: 'Nem genbestilling af dine tidligere bestillinger',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Bestilling blev ikke fundet, prøv igen',
                    booking_not_found: 'Reservationen findes ikke. Den er muligvis blevet slettet',
                    generic: 'Noget gik galt, prøv igen eller kontakt os',
                },
                connection: {
                    connected: 'Live opdateringer',
                    connecting: 'Live opdateringer er forbundet',
                    disconnected: 'Live opdateringer er afbrudt',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Advarsel',
                    title: 'Log ud',
                    body: 'Hvis du logger ud tømmes kurven',
                    cancel: 'Annullere',
                    proceed: 'Fortsæt',
                },
                order_restart: {
                    warning: 'Advarsel',
                    title: 'Ændre Bestillingsdetaljer',
                    body: 'Ændring af bestillingsdetaljerne kan fjerne retter i kurven, hvis de i mellemtiden er blevt udsolgt',
                    cancel: 'Annullere',
                    proceed: 'Fortsæt',
                },
                order_expired: {
                    subtitle: 'Vigtigt',
                    title: 'Bestillingen blev straks ændret',
                    description: "Din valgte tidspunkt er lige om hjørnet. Din bestilling er derfor ændret til 'Hurtigst Muligt'",
                    button: 'Ok',
                },
                order_expiring: {
                    subtitle: 'Vigtigt',
                    title: 'Deadline For Bestilling Udløber Snart',
                    description: 'Din bestilling skal ske inden {{time, timeFromTimestamp}} ellers vil den ikke længere være tilgængelig.',
                    button: 'Okay',
                },
            },
        },
        sections: {
            nav_top: {
                guest: 'Gæst',
                login: 'Login',
                login_signup: 'Login / Registrer',
                logout: 'Log ud',
            },
            menus: {
                info: {
                    no_menus: 'Der er i øjeblikket ingen menu tilgængelig',
                    restrictions: 'Menu Betingelser',
                    not_available: 'Menuen Er Ikke Tilgængelig',
                    unavailable: {
                        times: 'Menu ikke tilgængelig, dine betingelser matcher ikke nedenstående',
                        services: 'Menu ikke tilgængelig, dine betingelser matcher ikke nedenstående',
                        hours: 'Menu ikke tilgængelig, det valgte tidspunkt er ikke indenfor vores tilgængelige tider',
                        pre_order: 'Menu ikke tilgængelig, din bestilling passer ikke med genbestillings-betingelserne.',
                        age: 'Menu ikke tilgængelig, du skal logge ind med en alders verificeret konto for at bestille fra menuen',
                    },
                    services: {
                        title: 'Betingelser For Bestilling',
                        pickup: 'Selv Hent',
                        delivery: 'Levering',
                        dine_in: 'Spiser Her',
                    },
                    times: {
                        now: 'Ingen Forudbestillinger',
                        later: 'Kun Forudbestillinger',
                    },
                    hours: {
                        title: 'Tilgængelige Tider',
                    },
                    preorder: {
                        title: 'Betingelser For Forudbestilling',
                        days_in_advance: 'Skal bestilles {{days}} dage i forvejen',
                        cutoff_time: 'Dagens sidste tidspunkt er {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Aldersbegrænsning',
                        approved: 'Din konto er verificeret, du kan bestille fra menuen',
                        rejected: 'Kræver en alders verificeret konto. Opret en konto og insend dit ID',
                    },
                },
                search: {
                    title: 'Søg',
                    no_result: 'Ingen resultater, prøv igen.',
                    placeholder: 'Søg i menuen',
                },
            },
            info: {
                location: {
                    title: 'Adresse',
                    view_map: 'Se Kort',
                    phone: 'Telefon',
                },
                hours: {
                    title: 'Åbningstider',
                    title_special: 'Specielle Åbningstider',
                },
                services: {
                    title: 'Services',
                    notes: 'Kommentar',
                    delivery: {
                        ranges: 'Rækkevidde',
                        zones: 'Leveringsområder',
                        view_zones: 'Se På Kortet',
                        fee: 'Leveringsgebyr',
                        fee_short: 'Gebyr',
                        fee_varies: 'Variationer, vises i kurven',
                        min_order: 'Mindste Bestilling',
                        min_order_short: 'Min. best.',
                        no_min_order: 'Ingen Mindste Bestilling',
                        free_amount: 'Antal Gratis Levering',
                    },
                },
            },
            contact: {
                title: 'Kontakt os',
                name: 'Navn',
                email: 'E-mail',
                phone: 'Telefonnummer',
                message: 'Din besked..',
                send: 'Send',
                success: 'Beskeden er sendt',
                error: 'Øv.. noget gik galt, prøv igen',
            },
            footer: {
                powered_by: 'Powered By',
                terms_and_conditions: 'Betingelser & Vilkår',
            },
        },
        pages: {
            payment_completed: {
                title: 'Din betaling er blevet behandlet. Tak for din ordre!',
                subtitle: 'Ordreoplysningerne er sendt til din e-mailadresse.',
                back_to_menu: 'Tilbage',
                close_tab: 'Luk fanen',
            },
            payment_failed: {
                title: 'Desværre opstod der en fejl under behandlingen af din betaling.',
                subtitle: '',
                back_to_menu: 'Prøv igen',
                close_tab: 'Luk fanen',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Kvittering',
            details: {
                datetime: 'Booking Den',
                number_of_people: 'Antal Personer',
                placed: 'Booked',
                updated: 'Sidst Opdateret',
                notes: 'Kommentar',
                name: 'Navn',
                email: 'E-Mail',
                phone: 'Telefonnummer',
                store_address: 'Vores Adresse',
            },
            status_update: {
                title: 'Booking {{number}} Er Opdateret',
                body: 'Din booking status er blevet opdateret til {{status}}',
            },
            email_status_update_customer: {
                subject: 'Reservation #{{number}} – {{subjectLabel}}',
                body: 'Din reservation #{{number}} hos {{store}} er nu {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'Ordre #{{number}} – {{subjectLabel}}',
        header: 'Opdateret klar-tidspunkt',
        title: 'Opdateret klar-tidspunkt',
        order_number: 'Ordrenummer: {{number}}',
        description: 'Din ordre er nu klar kl. {{time}}.',
        order_time_updated_to: 'Tidspunktet for din ordre er blevet opdateret.',
        powered_by: 'Drevet af {{name}}',
        button_text: 'Spor ordre',
        subject_label: 'Opdateret klar-tidspunkt',
        subject_label_delivery: 'Opdateret leveringstidspunkt',
        body_ready: 'Din ordre er nu klar kl. {{time}}.',
        body_delivery: 'Din ordre bliver nu leveret kl. {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Anslået tid for at maden er færdig',
            est_driver_pickup_time: "Anslået tid for 'under levering'",
            est_delivery_time: 'Anslået Leveringstid',
            tab_details: 'Detaljer',
            tab_dishes: 'Retter',
            details: {
                status: 'Status',
                placed: 'Bestilt',
                due: 'Til',
                due_asap: 'Hurtigst Muligt',
                last_updated: 'Sidst Opdateret',
                total: 'Total',
                type: 'Type',
                table: 'Bord',
                number_of_people: 'Antal Personer',
                payment_method: 'Betalingsmetode',
                payment_status: 'Betalings status',
                payment_currency: 'Valuta',
                notes: 'Kommentar',
                name: 'Navn',
                email: 'E-Mail',
                phone: 'Telefon',
                distance: 'Rækkevidde',
                driving_time: 'Tidspunkt For Levering',
                delivery_zone: 'Område',
                delivery_address: 'Leveringsadresse',
                delivery_tracking: 'Track Levering',
                delivery_tracking_link: 'Live tracking link',
                tookan_status: 'Tookan-status',
                tookan_status_failed_book: 'Kunne ikke bestille levering',
                tookan_status_failed_update: 'Kunne ikke opdatere bestilling',
                tookan_status_success: 'Bestilt til levering',
                store_address: 'Vores Adresse',
            },
            dishes: {
                headings: {
                    quantity: 'Antal',
                    item: 'Vare',
                    price: 'Pris',
                },
                notes: 'Kommentar',
                remove_ingredients: 'Fjern',
            },
            status_update: {
                title: 'Bestilling {{number}} Er Opdateret',
                body: 'Din bestillings status er blevet opdateret til {{status}}',
            },
            wait_time_update: {
                title: 'Bestilling {{number}} Er Opdateret',
                body: 'Din bestilling er blevet opdateret',
            },
            delivery_update: {
                title: 'Bestilling {{number}} Er Opdateret',
                body: 'Levering er bestilt! Track din bestilling',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: 'New Order ({{number}}) - {{name}}',
                powered_by: 'Powered By {{name}}',
                overview: 'New Order Notification',
                title: 'New Order Placed At {{name}}',
                subtitle: 'Order Number {{number}}',
                description: 'View details and updates through your admin dashboard',
                button_text: 'Følg bestilling',
                track_delivery_button_text: 'Spor levering',
            },
            email_new_order_customer: {
                subject: 'Ordrekvittering ({{number}})',
                powered_by: 'Powered By {{name}}',
                overview: 'New Order Notification',
                title: 'New Order Placed At {{name}}',
                subtitle: 'Order Number {{number}}',
                description: 'View details and updates through your real-time online receipt',
                button_text: 'Følg bestilling',
                track_delivery_button_text: 'Spor levering',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) inkl. i prisen',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Leveringsgebyr',
            promo: 'Rabatkode: {{name}} ({{value, currency}} + {{percent}}% af Prisen)',
            promo_percent: 'Rabatkode: {{name}} ({{percent}}%)',
            promo_fixed: 'Rabatkode: {{name}}',
            promo_none: 'Rabatkode: {{name}}',
            cart: 'Kurv',
            tip: 'Drikkepenge',
            total: 'Total',
        },
        status: {
            unconfirmed: 'Ikke Bekræftet',
            awaiting_payment: 'Afventer Betaling',
            confirmed: 'Bekræftet',
            ready: 'Færdig',
            on_route: 'Under Levering',
            complete: 'Fuldført',
            cancelled: 'Afbrudt',
            seated: 'Placeret',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Ikke Tilgængelig',
                },
            },
            dish: {
                no_stock: 'Udsolgt',
                not_available: 'Ikke Tilgængelig',
            },
        },
    },
};
//# sourceMappingURL=da.js.map